/**
 * Primitive value conventions shared by every app and service.
 * See docs/adr/0001-money-and-quantity.md.
 */

/** UUID v4/v7 string. Generated on the client so records can be created offline. */
export type Id = string;

/** ISO-8601 timestamp in UTC, e.g. "2026-09-27T10:24:00.000Z". */
export type IsoDateTime = string;

/**
 * Money as an integer number of minor units of the business currency.
 * UZS has scale 0 in practice (1 сум = 1 unit); USD would have scale 2 (cents).
 * Never store money as a float.
 */
export type Money = number;

/**
 * Quantity as an integer number of thousandths ("milli-units") of the product unit.
 * 1 piece = 1000, 1.25 kg = 1250, 0.5 l = 500.
 */
export type Qty = number;

/** Number of thousandths in one whole unit of quantity. */
export const QTY_SCALE = 1000;

/** Tax / discount rate in basis points: 1200 = 12%. */
export type BasisPoints = number;
